import React from "react";
import { useSelector } from "react-redux";

import Modal from "./Modal";
import { CONNECT_WALLET, MODAL_CLOSE } from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";

const ConnectModal = ({ isVisible, onClose, onConnect, icxAmount }) => {
  const icxInUSD = useSelector((state) => state.icxPricing.price);

  const handleClick = () => {
    onClose();
    onConnect();
  };

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="connect-modal card px-3 py-4 position-relative"
    >
      <div className="header">
        <span
          onClick={() => onClose()}
          onKeyPress={(e) => e.code == "Enter" && onClose()}
          className="close-modal"
        >
          <img src={MODAL_CLOSE.SOURCE} alt="close" />
        </span>
        <h4>Buy GangstaBet</h4>
        <p className="text">
          Total Price: {icxAmount} ICX ($
          {/* {replaceFloatValue(icxAmount * icxInUSD)}) */}
        </p>
      </div>
      <div className="body py-3">
        <figure className="connect-wallet rounded-pill">
          <img src={CONNECT_WALLET.SOURCE} alt="connect" />
        </figure>
        <p className="text">
          You haven’t connected your wallet yet. Please connect
          <br /> your wallet to buy this gangstabet
        </p>
      </div>
      <div className="footer">
        <button className="btn btn-primary text-white" onClick={handleClick}>
          Connect Wallet
        </button>
      </div>
    </Modal>
  );
};

export default ConnectModal;
